// src/lib/opportunity/formatPaymentMilestoneClient.ts

import { opportunityFetch } from "./opportunityFetch.js";
import type { OpportunityFormatKey } from "../../types/opportunity.js";
import type {
  FormatPaymentAmountMode,
  FormatPaymentMilestone,
  FormatPaymentMilestoneRole,
} from "./formatPaymentMilestoneTypes.js";

export function listFormatPaymentMilestones(filters: {
  format_key: OpportunityFormatKey;
  product_type: string;
}) {
  const q = new URLSearchParams({
    format_key: filters.format_key,
    product_type: filters.product_type,
  });
  return opportunityFetch<{ ok: true; milestones: FormatPaymentMilestone[] }>(
    `/api/opportunity/format-payment-milestone-list?${q.toString()}`,
    { method: "GET" },
  );
}

export type UpsertFormatPaymentMilestonePayload = {
  id?: string;
  format_key: OpportunityFormatKey;
  product_type: string;
  milestone_role: FormatPaymentMilestoneRole;
  sort_order: number;
  label: string;
  subtext: string | null;
  amount_mode: FormatPaymentAmountMode | null;
  default_amount: number | null;
  line_item_ref: string | null;
};

export function upsertFormatPaymentMilestone(payload: UpsertFormatPaymentMilestonePayload) {
  return opportunityFetch<{ ok: true; milestone: FormatPaymentMilestone }>(
    "/api/opportunity/format-payment-milestone-upsert",
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    },
  );
}

export function deleteFormatPaymentMilestone(id: string) {
  return opportunityFetch<{ ok: true }>("/api/opportunity/format-payment-milestone-delete", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ id }),
  });
}

export function reorderFormatPaymentMilestones(payload: {
  format_key: OpportunityFormatKey;
  product_type: string;
  ordered_ids: string[];
}) {
  return opportunityFetch<{ ok: true }>("/api/opportunity/format-payment-milestone-reorder", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
}
